export default "__VITE_ASSET__BKG3oLA6__"